const applyRect = (node, targetEl, titleNode, label) => {
  const target = targetEl?.Flex?.node || targetEl?.node
  if (!target?.getBoundingClientRect) {
    node.style.display = 'none'
    return false
  }
  const { x, y, width, height } = target.getBoundingClientRect()
  node.style.display = 'block'
  node.style.transform = `translate3d(${x}px, ${y}px, 0)`
  node.style.width = `${width}px`
  node.style.height = `${height}px`
  if (titleNode) titleNode.textContent = label || ''
  return true
}

export const CanvasOverlay = {
  position: 'fixed',
  inset: '0',
  pointerEvents: 'none',
  overflow: 'hidden',

  childExtends: {
    data: {},
    position: 'absolute',
    round: 'W'
  },

  Hovered: {
    outline: '#2485F0 1.5px solid',
    display: 'none',

    Title: {
      tag: 'span',
      position: 'absolute',
      top: '-A2',
      left: '0',
      fontSize: 'Z',
      fontFamily: 'smbls',
      color: 'title',
      whiteSpace: 'nowrap',
      pointerEvents: 'none',
      textShadow: '0 2px 2px rgba(35, 35, 35, 0.5)',
      transformOrigin: '0 0',
      transform: 'translate3d(0, -40%, 0)'
    },

    DragHandler: {}
  },

  Selected: {
    display: 'none',

    SelectedNavbar: {},

    Rect: {
      position: 'absolute',
      inset: '0',
      outline: '#2485F0 2.25px solid',
      DragHandler: {}
    },

    ResizeOverlay: {}
  },

  LayerHovered: {
    outline: '#2485F0CC 1px solid',
    display: 'none'
  },

  LayerSelected: {
    outline: '#2485F0 2.5px solid',
    display: 'none',
    SelectedLayerNavbar: null
  },

  HoveredExtendComponent: {
    outline: '#E9823222 1px solid',
    background: '#E9823222',
    display: 'none'
  },

  SelectedExtendComponent: {
    outline: '#E9823222 2.25px solid',
    background: '#E9823222',
    display: 'none'
  },

  onFrame: (el) => {
    const gs = window.__canvasGlobalScope || el.context?.globalScope
    if (!gs) return

    const { hovered, hoveredKey, selected, selectedKey } = gs
    const isPanning = gs.panningMode || gs.isGrabbing

    // --- Hovered ---
    if (isPanning || !hovered || hovered === selected) {
      if (el.Hovered.node.style.display !== 'none') {
        el.Hovered.node.style.display = 'none'
      }
    } else {
      applyRect(el.Hovered.node, hovered, el.Hovered.Title?.node, hoveredKey)
    }

    // --- Selected ---
    if (!selected || isPanning) {
      if (el.Selected.node.style.display !== 'none') {
        el.Selected.node.style.display = 'none'
      }
    } else {
      applyRect(el.Selected.node, selected, null, selectedKey)

      // Always sync navbar title — reactive effect has no sources from creation
      const navbar = el.Selected.SelectedNavbar
      const textEl = navbar?.NavbarButtonSet_title?.Text
      if (textEl?.node && textEl.node.textContent !== selectedKey) {
        if (navbar?.state) {
          navbar.state.key = selectedKey
          // Ensure isEditMode stays false (it's set to true on element.update({force:true}))
          if (navbar.state.isEditMode) navbar.state.isEditMode = false
        }
        textEl.node.textContent = selectedKey || ''
      }
    }

    // --- Layer hover (inspect mode) ---
    if (gs.inspectMode && gs.hoverLayer && gs.layerHostComponent) {
      const collection = el.call('getCanvasCollection')
      if (collection) {
        let target = collection.lookdown?.(
          (child) => child.state?.key === gs.layerHostComponent
        )
        if (target) {
          for (const key of gs.hoverLayer) {
            if (target[key]) target = target[key]
          }
          if (target?.node) {
            applyRect(el.LayerHovered.node, target)
          } else {
            el.LayerHovered.node.style.display = 'none'
          }
        }
      }
    } else if (el.LayerHovered?.node?.style.display !== 'none') {
      el.LayerHovered.node.style.display = 'none'
    }
  }
}

export const DropOverlay = {
  position: 'absolute',
  inset: 'X',
  round: 'Z2',
  outline: '#2485F099 2px solid',
  background: '#2485F026',
  opacity: '0',
  visibility: 'hidden',
  pointerEvents: 'none',
  zIndex: 1,
  transition: 'B2 defaultBezier',
  transitionProperty: 'visibility, opacity'
}
